// extracted by mini-css-extract-plugin
module.exports = {"inheritDisplay":"_3bZNClC"};